"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable import/no-default-export */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-restricted-syntax */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
const react_1 = __importStar(require("react"));
const de_ui_1 = require("@delab-team/de-ui");
const react_i18next_1 = require("react-i18next");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const react_router_dom_1 = require("react-router-dom");
const qr_scanner_1 = __importDefault(require("qr-scanner"));
const framer_motion_1 = require("framer-motion");
const ton_core_1 = require("ton-core");
const TonConnect_1 = require("../../logic/tonconnect/TonConnect");
const main_header_1 = require("./main-header");
const tonapi_1 = require("../../logic/tonapi");
const rawToTon_1 = require("../../helpers/rawToTon");
const smlAddr_1 = require("../../helpers/smlAddr");
const useNftList_1 = require("../../hooks/useNftList");
const svg_selector_1 = require("../../assets/svg-selector");
const receive_modal_1 = require("./send/receive-modal");
const nft_1 = require("./nft");
const history_1 = require("./history");
const assets_1 = require("./assets");
const send_1 = require("./send");
const connect_1 = require("../../components/connect");
const transaction_detail_1 = require("./transaction-detail");
const buy_modal_1 = require("./buy-modal");
const jetton_detail_1 = require("./jetton-detail");
const nft_detail_1 = require("../nft-detail");
const TonConnectRemoteBridge_1 = require("../../logic/tonconnect/TonConnectRemoteBridge");
const main_module_css_1 = __importDefault(require("./main.module.css"));
const useLoadUserData_1 = require("../../hooks/useLoadUserData");
const wallet_1 = require("../../logic/wallet");
const getClient_1 = require("../../utils/getClient");
const telegram_banner_1 = require("../../components/telegram-banner");
function restoreSpecialChars(input) {
    // Заменяем --AA-- на %
    let result = input.replace(/--PERCENT--/g, '%');
    // Заменяем --BB-- на .
    result = result.replace(/--DOTSCH--/g, '.');
    return result;
}
const Main = (props) => {
    const location = (0, react_router_dom_1.useLocation)();
    const TgObj = sdk_1.default;
    const wallet = new wallet_1.CustomWallet((0, getClient_1.getDeLabClient)());
    const { getJettons } = (0, useLoadUserData_1.useLoadUserData)();
    const [firstRender, setFirstRender] = react_1.default.useState(false);
    const [firstRenderConnections, setFirstRenderConnections] = react_1.default.useState(false);
    const [activeTab, setActiveTab] = react_1.default.useState('Assets');
    /* --------------------transaction--------------------*/
    const [transHistory, setTransHistory] = react_1.default.useState(undefined);
    const [transDetail, setTransDetail] = react_1.default.useState(undefined);
    const [transLoading, setTransLoading] = react_1.default.useState(false);
    const [emptryRrans, setEmptryRrans] = react_1.default.useState(false);
    /* --------------------/transaction--------------------*/
    // send-status
    const [sendStatus, setSendStatus] = react_1.default.useState(false);
    const [position, setPosition] = react_1.default.useState(0);
    // / send-status
    // show nft detail
    const [showNftDetail, setShowNftDetail] = react_1.default.useState(false);
    // tonconnect
    const [tonconnectTransactionProps, setTonconnectTransactionProps] = react_1.default.useState(undefined);
    console.log('tonconnectTransactionProps', tonconnectTransactionProps);
    const [connectModalProps, setConnectModalProps] = react_1.default.useState(undefined);
    const [connectedApps, setConnectedApps] = react_1.default.useState([]);
    // first deploy
    const [deployProps, setDeployProps] = react_1.default.useState(undefined);
    //= =======================================================================================================================================================
    // BUY MODAL STATES
    const [sendData, setSendData] = (0, react_1.useState)({
        token: '',
        tokenAddress: '',
        amount: '',
        availableBalance: ''
    });
    const [positionBuy, setPositionBuy] = (0, react_1.useState)(0);
    //= =======================================================================================================================================================
    const { nftList, isLoading, loadNftList } = (0, useNftList_1.useNftList)(props.addressUser);
    (0, react_1.useEffect)(() => {
        loadNftList();
    }, []);
    (0, react_1.useLayoutEffect)(() => {
        window.document.body.scrollTo(0, 0);
    }, []);
    //= =======================================================================================================================================================
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(() => {
        if (!props.addressUser) {
            return;
        }
        if (ton_core_1.Address.parse(props.addressUser).toString({ bounceable: false }) === 'UQB5O2cMOOuyeQ03fRTDPDCnRi1eXJZbumRQqXIZzDqKoTQn') {
            navigate('/apps');
            TgObj.BackButton.hide();
            TgObj.MainButton.hide();
        }
    }, [props.addressUser]);
    const deployTrans = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        if (!props.addressUser) {
            return;
        }
        setDeployProps({
            address: props.addressUser,
            amount: '0.1'
        });
        props.setShowSendModal(true);
    };
    const tonapi = new tonapi_1.TonApi();
    async function getTrans(address) {
        try {
            setTransLoading(true);
            const res = await tonapi.getEventsAccount(address, 100);
            if (!res) {
                setEmptryRrans(true);
                return;
            }
            setTransHistory(res?.events);
            setEmptryRrans(false);
        }
        catch (error) {
            setEmptryRrans(true);
            console.error('Error fetching transactions:', error);
        }
        finally {
            setTransLoading(false);
        }
    }
    (0, react_1.useEffect)(() => {
        if (!firstRender && props.addressUser) {
            setFirstRender(true);
            getTrans(props.addressUser);
        }
    }, [props.addressUser]);
    const { t } = (0, react_i18next_1.useTranslation)();
    // deploy unactive wallet
    const [walletActive, setWalletActive] = (0, react_1.useState)(true);
    const SetStatus = async (address) => {
        if (address) {
            try {
                const res = await tonapi.getWalletInfo(address);
                if (res?.status !== 'active') {
                    setWalletActive(false);
                }
                else if (res?.status === 'active') {
                    setWalletActive(true);
                }
            }
            catch (err) {
                console.error(err);
            }
        }
    };
    (0, react_1.useEffect)(() => {
        SetStatus(props.addressUser);
    }, [props.addressUser]);
    const urlSearch = (0, react_1.useMemo)(() => new URLSearchParams(location.search), [location.search]);
    // tonconnect in TWA
    (0, react_1.useEffect)(() => {
        const initTgData = TgObj.initData;
        console.log('initTgData', initTgData);
        const initializeTgTonconnect = () => {
            console.log('START CONNECT FROM INIT DATA');
            const paramsArray = initTgData.split('&');
            const startParam = paramsArray.find(param => param.startsWith('start_param='));
            console.log('startParam', startParam);
            if (startParam !== undefined && startParam) {
                const startParamValue = startParam.split('=')[1]; // search params fron tg start_param
                const regex = /tonconnect-v__(\d+)-id__([^-\s]+)-r__(.*)-(ret__([^-\s]+))?/;
                const match = startParamValue.match(regex);
                if (match) {
                    const v = match[1];
                    const id = match[2];
                    const r = match[3];
                    const ret = match[5];
                    console.log('MATCHED R', r);
                    if (ret) {
                        TonConnectRemoteBridge_1.TonConnectRemoteBridge.setReturnStrategy(ret);
                    }
                    if (id && v && r) {
                        // const outputR = restoreSpecialChars(r)
                        const tgTonConnectQuerry = {
                            v,
                            r,
                            id
                        };
                        console.log('catch tonconnect initial tgTonConnectQuerry', tgTonConnectQuerry);
                        TonConnectRemoteBridge_1.TonConnectRemoteBridge.handleConnectDeeplink(tgTonConnectQuerry, props.setShowConnectModal, setConnectModalProps, setConnectedApps, connectedApps);
                    }
                }
            }
        };
        console.log('initializeTgTonconnect in effect');
        try {
            if (initTgData) {
                initializeTgTonconnect();
            }
        }
        catch (err) {
            console.log(err);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        try {
            const id = urlSearch.get('id');
            const v = urlSearch.get('v');
            const r = urlSearch.get('r');
            const ret = urlSearch.get('ret');
            if (ret) {
                TonConnectRemoteBridge_1.TonConnectRemoteBridge.setReturnStrategy(ret);
            }
            if (id && v && r) {
                const urlTonConnectQuerry = {
                    v,
                    r,
                    id
                };
                console.log('catch tonconnect initial', urlTonConnectQuerry);
                TonConnectRemoteBridge_1.TonConnectRemoteBridge.handleConnectDeeplink(urlTonConnectQuerry, props.setShowConnectModal, setConnectModalProps, setConnectedApps, connectedApps);
            }
        }
        catch (err) {
            console.log(err);
        }
    }, [urlSearch]);
    (0, react_1.useEffect)(() => {
        if (props.urlTonConnectQRQuerry) {
            TonConnectRemoteBridge_1.TonConnectRemoteBridge.handleConnectDeeplink(props.urlTonConnectQRQuerry, props.setShowConnectModal, setConnectModalProps, setConnectedApps, connectedApps);
        }
    }, [props.urlTonConnectQRQuerry]);
    console.log('props.urlTonConnectQRQuerry', props.urlTonConnectQRQuerry);
    console.log('connectModalProps', connectModalProps);
    console.log('props.showConnectModal', props.showConnectModal);
    console.log('connectedApps', connectedApps);
    const loadStoredConnections = async () => {
        const storageConnections = await TonConnect_1.TonConnect.loadConnections();
        console.log('LOAD TONCONNECTIONS FROM STORAGE', storageConnections.connections);
        setConnectedApps(storageConnections.connections);
    };
    (0, react_1.useEffect)(() => {
        if (!firstRenderConnections) {
            setFirstRenderConnections(true);
            loadStoredConnections();
        }
    }, []);
    (0, react_1.useEffect)(() => {
        TonConnectRemoteBridge_1.TonConnectRemoteBridge.open(connectedApps, props.setShowSendModal, setTonconnectTransactionProps, setConnectedApps, connectedApps);
        return () => {
            TonConnectRemoteBridge_1.TonConnectRemoteBridge.close();
        };
    }, [connectedApps]);
    const [recordedScrollPosition, setRecordedScrollPosition] = react_1.default.useState(0);
    const modalContentRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        if (showNftDetail) {
            window.scrollTo({ top: 0 });
        }
        else if (modalContentRef.current) {
            window.scrollTo({ top: modalContentRef.current.scrollTop });
        }
    }, [showNftDetail]);
    const checkCamera = async () => {
        const hasCamera = await qr_scanner_1.default.hasCamera();
        if (!hasCamera) {
            TgObj.showAlert(t('send.send-to-position.no-camera-found'));
            props.setUrlTonConnectQRQuerry(undefined);
            TgObj.BackButton.hide();
        }
        else {
            navigate('/qr');
        }
    };
    function packHistory(history) {
        const transPack = [[history[0]]];
        for (let i = 1; i < history.length; i++) {
            if (transPack.length !== 0) {
                if (transPack[transPack.length - 1][0].utime === history[i].utime) {
                    transPack[transPack.length - 1].push(history[i]);
                }
                else {
                    transPack.push([history[i]]);
                }
            }
            else {
                transPack.push([history[i]]);
            }
        }
        return transPack;
    }
    function chAU(address1) {
        if (!address1)
            return false;
        return (0, rawToTon_1.rawToTon)(address1.address) === props.addressUser;
    }
    function checkAndReturnAddress(address1, address2) {
        if (address1 && !address2) {
            let res = (0, smlAddr_1.smlAddr)((0, rawToTon_1.rawToTon)(address1.address));
            if (address1.name && address1.name !== '')
                res = address1.name;
            return res;
        }
        if (address2 && !address1) {
            let res = (0, smlAddr_1.smlAddr)((0, rawToTon_1.rawToTon)(address2.address));
            if (address2.name && address2.name !== '')
                res = address2.name;
            return res;
        }
        if (!address1 && !address2) {
            return '';
        }
        if (props.addressUser && address1 && address2) {
            if ((0, rawToTon_1.rawToTon)(address1.address) === props.addressUser) {
                let res = (0, smlAddr_1.smlAddr)((0, rawToTon_1.rawToTon)(address2.address));
                if (address2.name && address2.name !== '')
                    res = address2.name;
                return res;
            }
            let res = (0, smlAddr_1.smlAddr)((0, rawToTon_1.rawToTon)(address1.address));
            if (address1.name && address1.name !== '')
                res = address1.name;
            return res;
        }
        if (!props.addressUser && address1 && address2) {
            let res = (0, smlAddr_1.smlAddr)((0, rawToTon_1.rawToTon)(address1.address));
            if (address1.name && address1.name !== '')
                res = address1.name;
            return res;
        }
        return '';
    }
    // const tabs = [ 'Assets', 'History', 'NFT' ]
    const getTransformValues = () => {
        switch (activeTab) {
            case 'History':
                return { x: '-50%', y: '-50%' };
            case 'Assets':
                return { x: '-157%', y: '-50%' };
            case 'NFT':
                return { x: '57%', y: '-50%' };
            default:
                return { x: '-157%', y: '-50%' };
        }
    };
    const transformValues = getTransformValues();
    // ----------
    const getUserData = async (address) => {
        if (address === undefined) {
            return false;
        }
        const res = await getJettons(address);
        console.log('START GET USER DATA (total balance, tokensData, tonBalance, histore)');
        if (!res) {
            return false;
        }
        props.setTotalBalance(res?.totalBalance);
        props.setTokensData(res?.tokensData);
        props.setWalletBalanceTON(res?.tonBalance);
        console.log('get trans history');
        getTrans(address);
        return true;
    };
    // eslint-disable-next-line no-promise-executor-return
    const delay = (delayInms) => new Promise(resolve => setTimeout(resolve, delayInms));
    const reloadData = async (address, delayMS) => {
        await delay(delayMS);
        console.log('RELOAD USER DATA');
        await getUserData(address);
    };
    (0, react_1.useEffect)(() => {
        if (props.addressUser) {
            reloadData(props.addressUser, 5000);
        }
    }, [props.addressUser, showNftDetail, props.showSendModal, props.showJettonDetail]);
    (0, react_1.useLayoutEffect)(() => {
        const checkPincode = async () => {
            const isPinCode = await wallet.isPincodPassword();
            if (!isPinCode) {
                navigate('/changepsw');
            }
        };
        checkPincode();
    });
    return ((0, jsx_runtime_1.jsxs)("div", { ref: modalContentRef, style: { height: '100%', paddingBottom: '71px' }, children: [!showNftDetail && !props.showJettonDetail ? ((0, jsx_runtime_1.jsxs)("div", { className: main_module_css_1.default.mainPage, children: [(0, jsx_runtime_1.jsx)(main_header_1.MainHeader, { addressUser: props.headerAddressUser, isTg: props.isTg, totalBalance: props.totalBalance, checkCamera: checkCamera, setShowBuyModal: props.setShowBuyModal, setShowSendModal: props.setShowSendModal, setShowReceiveModal: props.setShowReceiveModal, reloadData: reloadData }), (!transLoading && !walletActive) && ((0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: main_module_css_1.default.deployPanel, children: [(0, jsx_runtime_1.jsxs)("div", { className: main_module_css_1.default.deployPanelInner, children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "alert2" }) }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: main_module_css_1.default.errorText, children: t('common.banner-text') })] }), (0, jsx_runtime_1.jsx)(framer_motion_1.motion.button, { onClick: deployTrans, className: main_module_css_1.default.deployBtn, children: t('common.deploy-wallet') })] })), (0, jsx_runtime_1.jsx)(telegram_banner_1.TelegramBanner, {}), (0, jsx_runtime_1.jsxs)(de_ui_1.Div, { className: main_module_css_1.default.tabPanel, children: [(0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { className: main_module_css_1.default.tabButtonDiv, animate: { transform: `translate(${transformValues.x}, ${transformValues.y})` }, transition: { duration: 0.3 } }), (0, jsx_runtime_1.jsx)(framer_motion_1.motion.button, { className: `${main_module_css_1.default.tabButton}`, onClick: () => {
                                    TgObj.HapticFeedback.impactOccurred('medium');
                                    setActiveTab('Assets');
                                }, children: t('main.navigation.assets') }), (0, jsx_runtime_1.jsx)(framer_motion_1.motion.button, { className: `${main_module_css_1.default.tabButton}`, onClick: () => {
                                    TgObj.HapticFeedback.impactOccurred('medium');
                                    setActiveTab('History');
                                }, children: t('main.navigation.history') }), (0, jsx_runtime_1.jsx)(framer_motion_1.motion.button, { className: `${main_module_css_1.default.tabButton}`, onClick: () => {
                                    TgObj.HapticFeedback.impactOccurred('medium');
                                    setActiveTab('NFT');
                                }, children: t('NFT') })] }), activeTab === 'NFT' && ((0, jsx_runtime_1.jsx)(nft_1.Nft, { addressUser: props.addressUser, isTg: props.isTg, nftDetail: props.nftDetail, setNftDetail: props.setNftDetail, showNftDetail: showNftDetail, setShowNftDetail: setShowNftDetail, setRecordedScrollPosition: setRecordedScrollPosition, nftList: nftList, isLoading: isLoading, offset: modalContentRef?.current?.scrollTop ? modalContentRef?.current?.scrollTop : 0 })), activeTab === 'History' && ((0, jsx_runtime_1.jsx)(history_1.History, { transHistory: transHistory, addressUser: props.addressUser, setTransDetail: setTransDetail, setShowTransactionDetail: props.setShowTransactionDetail, transLoading: transLoading, isTg: props.isTg })), activeTab === 'Assets' && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(assets_1.Assets, { isTg: props.isTg, tokensData: props.tokensData, setShowJettonDetail: props.setShowJettonDetail, setJettonDetailData: props.setJettonDetailData, tokensLoading: false, addressUser: props.addressUser }) }))] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [showNftDetail && ((0, jsx_runtime_1.jsx)(nft_detail_1.NftDetail, { nftDetail: props.nftDetail, setNftDetail: props.setNftDetail, setShowNftDetail: setShowNftDetail, addressUser: props.addressUser, transHistory: transHistory, packHistory: packHistory, chAU: chAU, checkAndReturnAddress: checkAndReturnAddress, isTg: props.isTg, 
                        // psw
                        psw: props.psw, walletBalanceTON: props.walletBalanceTON })), props.showJettonDetail && ((0, jsx_runtime_1.jsx)(jetton_detail_1.JettonDetailModal, { showJettonDetail: props.showJettonDetail, setShowJettonDetail: props.setShowJettonDetail, 
                        // jetton detail data
                        jettonDetailData: props.jettonDetailData, setJettonDetailData: props.setJettonDetailData, addressUser: props.addressUser, isTg: props.isTg, 
                        // ton history
                        transHistory: transHistory, packHistory: packHistory, chAU: chAU, checkAndReturnAddress: checkAndReturnAddress, transDetail: transDetail, setTransDetail: setTransDetail, showTransactionDetail: props.showTransactionDetail, setShowTransactionDetail: props.setShowTransactionDetail, 
                        // receive modal
                        setShowReceiveModal: props.setShowReceiveModal, 
                        // send data
                        setSendData: props.setSendData, sendData: props.sendData, setShowSendModal: props.setShowSendModal, setPosition: setPosition, setTokenSwap: props.setTokenSwap, selectedLanguage: props.selectedLanguage, buyData: sendData, setBuyData: setSendData, setShowBuyModal: props.setShowBuyModal, setPositionBuy: setPositionBuy }))] })), props.showReceiveModal && (0, jsx_runtime_1.jsx)(receive_modal_1.ReceiveModal, { addressUser: props.addressUser, showReceiveModal: props.showReceiveModal, setShowReceiveModal: props.setShowReceiveModal }), props.showSendModal && (0, jsx_runtime_1.jsx)(send_1.SendModal, { showSendModal: props.showSendModal, setShowSendModal: props.setShowSendModal, addressUser: props.addressUser, isTg: props.isTg, 
                // success modal
                sendSuccess: sendStatus, setSendSuccess: setSendStatus, 
                // recent
                transHistory: transHistory, 
                // tokens data
                tokensData: props.tokensData, 
                // send data
                sendData: props.sendData, setSendData: props.setSendData, 
                // psw
                psw: props.psw, transFromEvent: props.transFromEvent, setTransFromEvent: props.setTransFromEvent, eventApi: props.eventApi, walletBalanceTON: props.walletBalanceTON, priceTON: props.priceTON, 
                // position
                position: position, setPosition: setPosition, 
                // tonconnect
                tonconnectTransactionProps: tonconnectTransactionProps, setTonconnectTransactionProps: setTonconnectTransactionProps, 
                // deploy
                deployProps: deployProps, setDeployProps: setDeployProps, setSkipUserAddress: props.setSkipUserAddress, skipUserAddress: props.skipUserAddress }), props.showTransactionDetail && (0, jsx_runtime_1.jsx)(transaction_detail_1.TransactionDetail, { showTransactionDetail: props.showTransactionDetail, setShowTransactionDetail: props.setShowTransactionDetail, transDetail: transDetail, setTransDetail: setTransDetail, isTg: props.isTg }), props.showBuyModal && (0, jsx_runtime_1.jsx)(buy_modal_1.BuyModal, { isTg: props.isTg, showBuyModal: props.showBuyModal, setShowBuyModal: props.setShowBuyModal, tokensData: props.tokensData, addressUser: props.addressUser, sendData: sendData, setSendData: setSendData, position: positionBuy, setPosition: setPositionBuy }), props.showConnectModal && ((0, jsx_runtime_1.jsx)(connect_1.ConnectModal, { addressUser: props.addressUser, showConnectModal: props.showConnectModal, setShowConnectModal: props.setShowConnectModal, connectModalProps: connectModalProps, psw: props.psw, isTg: props.isTg }))] }));
};
exports.default = Main;
